import createApp from '@shopify/app-bridge/development'
import { Redirect } from '@shopify/app-bridge/actions'
import { getSessionToken } from '@shopify/app-bridge-utils'
import store from '@/store/store'

export default {
  install(Vue) {
    const shopOrigin = store.state.shopOrigin
    const framed = window.top !== window.self
    if (!shopOrigin || !framed) return console.warn('Shopify app bridge could not be created.')
    const app = createApp({ apiKey: process.env.VUE_APP_SHOPIFY_API_KEY, shopOrigin })
    const redirect = Redirect.create(app)

    Vue.prototype.$shopify = {
      getSessionToken() {
        return getSessionToken(app)
      },
      redirectToAdminSection(section) {
        redirect.dispatch(Redirect.Action.ADMIN_SECTION, { name: section })
      },
      redirectToExternalUrl(url) {
        redirect.dispatch(Redirect.Action.REMOTE, url)
      }
    }
  }
}
